import { render, staticRenderFns } from "./NaoxjStockSaleSend.vue?vue&type=template&id=8ef2287a&scoped=true&"
import script from "./NaoxjStockSaleSend.vue?vue&type=script&lang=js&"
export * from "./NaoxjStockSaleSend.vue?vue&type=script&lang=js&"
import style0 from "./NaoxjStockSaleSend.vue?vue&type=style&index=0&id=8ef2287a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ef2287a",
  null
  
)

export default component.exports